"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isTransitionEndSupported;

function isTransitionEndSupported() {
  return !!(typeof window !== 'undefined' && 'TransitionEvent' in window);
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-dates/lib/utils/isTransitionEndSupported.js
 ** module id = 1255
 ** module chunks = 0
 **/